($ => {
	const LABEL_URL = '/action/addSiteLabel';

	function init() {
		$('.js-com-events-type').on('change', handleTypeChange);
		$('.com-events-price-table__admin-submit').on('click', saveAdminConfig);
		$('.com-events-price-table__admin-form-list').on('click', '.com-events-price-table__admin-form-item', removeElementFromList);
	}

	function handleTypeChange({currentTarget}) {
		let $e = $(currentTarget);
		let $tab = $e.closest('.stool-shared-tab-ctn'); 
		let { name, value } = currentTarget;
		
		$tab.find('.com-events-price-table__admin-form').hide();
		$tab.find(`.com-events-price-table__admin-form[data-id="${value}"]`).show();
	}
	
	function saveAdminConfig({currentTarget}) {
		let $e = $(currentTarget);
		let key = currentTarget.dataset.key;
		let $com = $e.closest('.js-events-admin-ctn');
		let valueEvents = '';
		let typeEvents = $('.js-com-events-type:checked', $com).val();
		let data = {
			countEvents: $com.find('input[name="count"]').val(),
			typeEvents
		};

		console.log(typeEvents);

		data.valueEvents = getValueByType($com.closest('.stool-shared-tab-ctn'), typeEvents);

		$com.find('.form-message').hide().removeClass('form-message_fade_out');
		$e.addClass('has-processing_active');
		$.ajax({
			url: LABEL_URL,
			type: 'POST',
			data: {
				key,
				value: JSON.stringify(data)
			},
			success: () => {
				let success = $com.find('.form-message_success');
				success.show();
				success.parent().hide().show(); // Force redraw for fade out to occur
				setTimeout(() => success.addClass('form-message_fade_out'), 1);
			},
			error: () => {
				let error = $com.find('.form-message_server-error');
				error.show().css();
				error.parent().hide().show(); // Force redraw for fade out to occur
				setTimeout(() => error.addClass('form-message_fade_out'), 1);
			},
			complete: () => {
				$e.removeClass('has-processing_active');
			}
		});
	}

	function getValueByType($tab, type) {
		if (type === 'category') {
			return $tab.find('.com-events-price-table__admin-form[data-id="category"] select').val();
		} else if (type === 'custom'){
			return $tab.find('.com-events__admin-form-item').map((i, el) => el.dataset.id).get().join();
		}
	}

	function removeElementFromList(e) {
		e.currentTarget.parentNode.removeChild(e.currentTarget);
	}

	$(init);
})(jQuery);